export default __webpack_public_path__ + "assets/models/b1c1eb9c7446718e8ded88b4f80ac979.glb";